import { PageListCachedDataSource } from './BaseDataSources';
import { ICountryState } from '../Interfaces';

export class CountryStateSource extends PageListCachedDataSource<ICountryState> {
  public constructor(countryId: string) {    
    super(`/datasource/countries/${countryId}/states`);
  }
}
